module.exports = __webpack_public_path__ + "static/media/ovalo.ebad9159.svg";